import type { HTMLAttributes, ReactNode } from 'react';

type BadgeTone = 'distrito' | 'accent' | 'success' | 'warning' | 'danger' | 'neutral';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  tone?: BadgeTone;
}

// Badges estilo "pill" SOLID — paleta Aurora distrital. Texto blanco sobre color
// pleno (no la versión light Tailwind tipo bg-green-100 text-green-800).
// Para semánticos (tier crítico/alto/medio/bajo) usar TierBadge dedicado.
const TONE_CLASSES: Record<BadgeTone, string> = {
  distrito: 'bg-distrito-500 text-white',
  accent: 'bg-accent-500 text-white',
  success: 'bg-green-600 text-white',
  warning: 'bg-amber-500 text-white',
  danger: 'bg-red-600 text-white',
  neutral: 'bg-gray-500 text-white',
};

export function Badge({ children, tone = 'distrito', className = '', ...rest }: BadgeProps) {
  return (
    <span
      className={`inline-block px-3 py-0.5 rounded-full text-xs font-semibold ${TONE_CLASSES[tone]} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
